import { API } from "../../api";


export const memberDashboardExtendedApi = API.injectEndpoints({
    endpoints: (builder) => ({
        memberDashboard: builder.query({
            query: () => {
                return {
                    url: "/members/dashboard?guard=member",
                    method: "GET",
                };
            },
            transformResponse: (responseData) => {
                return responseData?.data;
            },
            providesTags: [{ type: "member-dashboard" }],
        })
    })
})


export const {
    useMemberDashboardQuery
} = memberDashboardExtendedApi;
